import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import { CsvBuilder } from "filefy";
import sort from "fast-sort";

import _ from "lodash";

import { formatSecondsForDate } from "../../layout/utils/timeUtils";

export default (props) => {
  const download = () => {
    const rows = [];
    sort(props.reportData)
      .asc([(r) => r.created.seconds])
      .map((e) =>
        rows.push([
          e.name,
          e.email,
          e.rating,
          e.comment,
          formatSecondsForDate(e.created.seconds),
        ])
      );

    const date = new Date();
    const builder = new CsvBuilder(
      "nps_report" + date.toLocaleDateString() + ".csv"
    );
    builder
      .setDelimeter(",")
      .setColumns(["Name", "Email", "Rating", "Comment", "Date Submitted"])
      .addRows(rows)
      .exportFile();
  };

  return !_.isEmpty(props.reportData) && props.reportData.length > 0 ? (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          marginBottom: 20,
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          disabled={_.isEmpty(props.reportData) || props.reportData.length < 1}
          onClick={download}
        >
          Download Survey Results
        </Button>
      </div>
      <TableContainer
        component={Paper}
        style={{ maxHeight: 400, overflow: "auto" }}
      >
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "#f5f5f5" }}>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell align="center">Rating</TableCell>
              <TableCell align="center">Comment</TableCell>
              <TableCell align="center">Date Submitted</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.reportData &&
              sort(props.reportData)
                .asc([(r) => r.created.seconds])
                .map((row) => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row">
                      {row.name ? row.name : "Anonymous"}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.email}
                    </TableCell>
                    <TableCell align="center">{row.rating}</TableCell>
                    <TableCell align="center">{row.comment}</TableCell>
                    <TableCell align="center">
                      {row.created && formatSecondsForDate(row.created.seconds)}
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  ) : (
    <h3>Your Patients/Clients have not submitted the NPS survey yet.</h3>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/NPSReport.js